export default {
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    getMutationBasedOnKey(actionName) {
      switch (actionName) {
        case "getSites":
          return "UPDATE_SITES";
        case "getSitesUpdatesV3":
          return "UPDATE_SITES_UPDATES";
        case "getPluginsAndThemesV3":
          return "UPDATE_PLUGINS_AND_THEMES";
        case "getGroupsSitesV3":
          return "SET_GROUPS";
        case "getSitesBackupsV3":
          return "SET_BACKUPS";
        case "getSites":
          return "SET_SITES";
        case "getClientUpdateAvailableSiteIDs":
          return "SET_CLIENT_PLUGIN_UPDATES";
        case "getHistoryPanelHTMLV3":
          return "SET_PANEL_HISTORY";
        default:
          return null;
      }
    },
    loadAddon(addonSlug) {
      switch (addonSlug) {
        case "googleAnalytics":
          return import(/* webpackChunkName: 'googleAnalytics/index' */ "@/components/addons/GoogleAnalytics/index");
        case "backupRepository":
          return import(/* webpackChunkName: 'backupRepository/index' */ "@/components/addons/BackupRepository/index");
        default:
          return Promise.resolve("addon_not_supported");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/utils.js